var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopRightArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.07 47.64V29.79L25.86 53 23 50.14l23.21-23.21H28.36L24.43 23H53v28.57l-3.93-3.93z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top-right_arrow_C.a7ffbc8e.svg";
export { SvgJ1TopRightArrowC as ReactComponent };